import { addNotification } from "layouts/AppLayout/modules/actions";
import { call, put, takeEvery } from "redux-saga/effects";
import { AUTH_LOGIN_FAILURE, AUTH_LOGIN_REQUEST, AuthLoginFailureAction, AuthLoginRequestAction, loginFailure as generateLoginFailureAction } from "../actions/AuthLogin";
import { LockType, showLock } from "./WebAuth";

export function* loginRequest(action: AuthLoginRequestAction) {
    const { state, codeChallenge } = action.payload;

    const mode = action.payload.lockType === LockType.SignUp ? "signup" : "login";
    // old way was always login
    // const mode = moveTo.indexOf("existingUser=false") < 0 ? "login" : "signUp";
    try {
        yield call(showLock, { mode, state, codeChallenge });
    } catch (error) {
        yield put(generateLoginFailureAction(error));
    }
}

export function* watchLoginRequest() {
    yield takeEvery(AUTH_LOGIN_REQUEST, loginRequest);
}

export function* loginFailure(action: AuthLoginFailureAction) {
    const { payload } = action;
    const { error } = payload;
    const message = error ? error.message : "Error unknown";
    yield put(addNotification(`Error attempting to log in: ${message}`, true));
}

export function* watchLoginFailure() {
    yield takeEvery(AUTH_LOGIN_FAILURE, loginFailure);
}